export function ensureOdd(n) {
  const num = Number(n) || 1
  return num % 2 === 0 ? num + 1 : num
}

export function buildScaleValues({ hangersCount, startValue, step }) {
  const count = ensureOdd(hangersCount)
  const s = Number(startValue) || 0
  const st = Number(step) || 1

  const values = []
  for (let i = 0; i < count; i++) values.push(s + i * st)

  return values
}

export function buildHangers(scaleValues) {
  return scaleValues.map((value, idx) => ({
    id: idx,
    value,
    weightCount: 0
  }))
}

export function addWeightToHanger(hangers, hangerId) {
  return hangers.map(h =>
    h.id === hangerId
      ? { ...h, weightCount: h.weightCount + 1 }
      : h
  )
}

export function removeWeightFromHanger(hangers, hangerId) {
  return hangers.map(h => {
    if (h.id !== hangerId) return h
    if (h.weightCount <= 0) return h
    return { ...h, weightCount: h.weightCount - 1 }
  })
}

export function moveOneWeight(hangers, fromHangerId, toHangerId) {
  if (fromHangerId === toHangerId) return hangers

  const from = hangers.find(h => h.id === fromHangerId)
  if (!from || from.weightCount <= 0) return hangers

  return hangers.map(h => {
    if (h.id === fromHangerId) return { ...h, weightCount: h.weightCount - 1 }
    if (h.id === toHangerId) return { ...h, weightCount: h.weightCount + 1 }
    return h
  })
}

export function deleteOneWeight(hangers, fromHangerId) {
  return hangers.map(h => {
    if (h.id !== fromHangerId) return h
    if (h.weightCount <= 0) return h
    return { ...h, weightCount: h.weightCount - 1 }
  })
}

export function computeBalance({ hangers, mastValue }) {
  const m = Number(mastValue)

  let left = 0
  let right = 0
  let nWeights = 0

  for (const h of hangers) {
    const count = h.weightCount
    if (!count) continue

    nWeights += count

    const d = h.value - m
    const dist = Math.abs(d) * count

    if (d < 0) left += dist
    else if (d > 0) right += dist
  }

  const diff = left - right
  const state = diff === 0 ? "balanced" : diff > 0 ? "left" : "right"

  const magnitude = Math.abs(diff)
  let tiltLevel = 0
  if (magnitude === 0) tiltLevel = 0
  else if (magnitude <= 2) tiltLevel = 1
  else if (magnitude <= 6) tiltLevel = 2
  else if (magnitude <= 12) tiltLevel = 3
  else tiltLevel = 4

  return {
    left,
    right,
    diff,
    state,
    tiltLevel,
    nWeights
  }
}

export function getCenterValue(scaleValues) {
  return scaleValues[Math.floor(scaleValues.length / 2)]
}

export function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n))
}